import React, { useMemo } from 'react'
import { ICellRendererParams } from 'ag-grid-community'
import { Avatar, Box } from '@mui/material'
import { styled } from '@mui/system'
import { colorPalette } from '../../../../../style/colorPalette'
import CustomTooltip from './CustomTooltip'
import { intl } from '../../../../../../i18n'

const ICON_SIZE = 21

const RootDiv = styled('div')({
  position: 'relative',
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
  margin: 0,
})

const RequestStatusText = styled(Box)({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
})

const ProxyUserIcon = styled(Avatar)({
  backgroundColor: colorPalette.monotone[2],
  height: ICON_SIZE,
  width: ICON_SIZE,
  position: 'absolute',
  right: '8px',
})

const RequestStatusCellRenderer: React.FC<ICellRendererParams> = props => {
  const { data, value, colDef } = props

  const projectUuid = colDef?.refData?.uuid
  const targetProjectStatus = useMemo(
    () =>
      data?.projectRequestStatus?.find(
        status => status.projectUuid === projectUuid
      ) || undefined,
    [data?.projectRequestStatus, projectUuid]
  )

  const tooltipValue = useMemo(() => {
    if (targetProjectStatus?.proxyUser) {
      return intl.formatMessage(
        { id: 'actualWorkingHours.requestStatus.proxyRequested' },
        { proxyUserName: targetProjectStatus.proxyUser.name }
      )
    }
    return ''
  }, [targetProjectStatus])

  return (
    <CustomTooltip value={tooltipValue}>
      <RootDiv>
        <RequestStatusText component="span">{value}</RequestStatusText>
        {targetProjectStatus?.proxyUser ? (
          <ProxyUserIcon
            src={targetProjectStatus?.proxyUser?.iconUrl}
            variant="circular"
          />
        ) : undefined}
      </RootDiv>
    </CustomTooltip>
  )
}

export default RequestStatusCellRenderer
